import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseElement } from "../../utils/ui-components.js";

@customElement("api-docs-getting-started")
export class ApiDocsGettingStarted extends BaseElement {
    @property({ type: String }) apiKey = "YOUR_API_KEY";
    @property({ type: String }) baseUrl = "https://appshovel.com";

    connectedCallback() {
        super.connectedCallback();
        this.style.display = "block";
    }

    render() {
        return html`
            <section class="space-y-4">
                <h2 class="text-2xl font-bold">Getting Started</h2>
                <p>Get up and running with the AppShovel API in three steps:</p>

                <div class="steps steps-vertical">
                    <div class="step step-primary">
                        <div class="text-left pl-4">
                            <p class="font-semibold">Create an API key</p>
                            <p class="text-base-content/60">
                                Go to <a href="/settings" class="link link-primary">Settings</a> and create an API key. Copy it — it's only shown
                                once.
                            </p>
                        </div>
                    </div>
                    <div class="step step-primary">
                        <div class="text-left pl-4">
                            <p class="font-semibold">Paste your key above</p>
                            <p class="text-base-content/60">
                                Enter your API key in the input field at the top of this page to populate all examples.
                            </p>
                        </div>
                    </div>
                    <div class="step step-primary">
                        <div class="text-left pl-4">
                            <p class="font-semibold">Make your first request</p>
                            <p class="text-base-content/60">Try fetching keyword popularities:</p>
                        </div>
                    </div>
                </div>

                <api-docs-code-block
                    .code=${`curl -X POST ${this.baseUrl}/api/v1/keywords/popularities \\
  -H "Authorization: Bearer ${this.apiKey}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "terms": ["weather", "fitness"],
    "country": "us",
    "platform": "iphone"
  }'`}
                ></api-docs-code-block>

                <p>You'll receive popularity and difficulty scores for each keyword:</p>

                <api-docs-code-block
                    .code=${`[
  {
    "term": "weather",
    "country": "us",
    "platform": "iphone",
    "popularity": 82,
    "difficulty": 95
  },
  {
    "term": "fitness",
    "country": "us",
    "platform": "iphone",
    "popularity": 67,
    "difficulty": 78
  }
]`}
                ></api-docs-code-block>

                <div class="p-4 bg-base-200 rounded-lg">
                    <p class="text-sm">
                        <span class="font-semibold">Machine-readable spec:</span> The full
                        <a href="/api/v1/openapi.json" class="link link-primary" target="_blank">OpenAPI specification</a>
                        is available for AI agents, CLI tools, and code generators.
                    </p>
                </div>
            </section>
        `;
    }
}
